module.exports={
  "modalContent" : {
    "invalidLogin" : {
      "title" : "Invalid Login / Password",
      "message" : "Invalid Login ID / Password"
    },
    "accountSuspendedLogin" : {
      "title" : "Account Suspended",
      "message" : "Your account has been suspended.  Please contact customer service."
    },
    "accountSuspendedForgotPassword" : {
      "title" : "Account Suspended",
      "message" : "Your account has been suspended. Please call the help desk at 1-800-294-9568, 8:00AM to 6:00PM ET."
    },
    "unexpectedError" : {
      "title" : "Error",
      "message" : "An unexpected error has occurred.  The server was unable to be contacted."
    },
    "ldapError" : {
      "title" : "LDAP Error",
      "message" : "An error has occurred interacting with LDAP."
    },
    "cpGenFailure" : {
      "title" : "Consumer Profile General Failure",
      "message" : "An general error has occurred with consumer profile."
    },
    "cpSearchFailure" : {
      "title" : "Consumer Profile Search Failure",
      "message" : "An error has occurred with consumer profile search."
    },
    "cpUpdateFailure" : {
      "title" : "Consumer Profile Update Failure",
      "message" : "An error has occurred with consumer profile update."
    },
    "noMatchMember" : {
      "title" : "No Match",
      "message" : "There was no match on the given information."
    },
    "noMatchMemberRegister" : {
      "title" : "No Match",
      "message" : "The information you have entered doesn't match the information we have on file for you. Please check your information again and reenter the correct information. If you are still having difficulty registering, call the toll-free number on the back of your member ID card."
    },
    "alreadyRegistered" : {
      "title" : "Already Registered",
      "message" : "Thank you for your interest in registering, but it appears you are already registered.  Please login from the main page."
    },
    "duplicateLogin" : {
      "title" : "Duplicate Login Error",
      "message" : "You have used a login ID already in use."
    },
    "invalidLoginID" : {
      "title" : "Choose a New Login ID",
      "message" : "Please choose a login ID that does not contain your member ID or SSN."
    },
    "duplicateEmail" : {
      "title" : "Duplicate Email Error",
      "message" : "You have used an email already in use."
    },
    "reservedEmail" : {
      "title" : "Reserved Email Error",
      "message" : "You have used an email that is a Highmark reserved email."
    },
    "reservedAndExistsEmail" : {
      "title" : "Reserved Email that Exists Error",
      "message" : "You have used an email that is a Highmark reserved email that is also already in use."
    },
    "temporaryPassword" : {
      "title" : "Temporary Password",
      "message" : "You have been assigned a temporary password.  It will need changed immediately."
    },
    "invalidZipCode" : {
      "title" : "Invalid Zip Code",
      "message" : "Please enter a valid zip code."
    },
    "outOfCoverageZipCode" : {
      "title" : "Zip Code Out of Coverage Area",
      "message" : "The ZIP code you entered is outside the service areas of the states in which we offer plans. Please confirm you entered the ZIP code correctly or call 1-888-630-BLUE, 8 a.m. to 8 p.m, seven days a week. TTY call 711."
    },
    "minimumAgeFailure" : {
      "title" : "Minimum Age Failure",
      "message" : "Only members who are of the minimum age or older can register online."
    },
    "wrongSiteRegistration" : {
      "title" : "You are registering on the wrong site",
      "message" : "Lorem ipsum dolor sit amet."
    },
    "forgotPasswordSupport" : {
      "title" : "Please call the help desk",
      "message" : "Please call the help desk at {customer_service_phone_number} to retrieve your username or password."
    },
    "pleaseSelect" : {
      "title" : "Please Select",
      "message" : "Please select an option."
    },
    "multipleUserNames" : {
      "title" : "Multiple User Names",
      "message" : "You have multiple user names.  Please contact customer service to retrieve your login information."
    },
    "forgotUserNameConfirmation" : {
      "title" : "Thank You!",
      "message" : "Your username will be sent immediately to the email address on file for you.  If you experience any problems, contact the help desk at {customer_service_phone_number}."
    },
    "forgotPasswordConfirmation" : {
      "title" : "Thank You!",
      "message" : "Your password will be sent immediately to the email address on file for you. Temporary password is valid for 5 days.  If you experience any problems, contact the help desk at {customer_service_phone_number}."
    },
    "pinSent" : {
      "title" : "Your request has been submitted",
      "message" : "Your PIN has been sent."
    },
    "pinAttemptsExceeded" : {
      "title" : "PIN Attempts Exceeded",
      "message" : "You have made at least {pinAttempts} attempts at requesting a PIN.  The PIN will be mailed to you through US Mail."
    },
    "v2mFailure" : {
      "title" : "Already Registered",
      "message" : "Thank you for your interest in registering, but it appears you are already registered.  Please login from the main page."
    },
    "confidentialCommunication" : {
      "title" : "Unable to Register",
      "message" : "You are unable to register for the portal. If you have questions about this issue, please call the toll-free number on the back of your member ID card."
    },
    "brandConflict": {
      "title": "Oops!",
      "message": "Oops. Sorry! We don't know who you are. So, we cannot give you access to this website. Please check to make sure you entered the website address you intended."
    },
    "invalidBrand": {
      "title": "Invalid Brand",
      "message": "Please try another zip code."
    },
    "invalidCurrentPassword": {
      "title": "Invalid Current Password",
      "message": "Please enter your correct current password."
    },
    "newCurrentPasswordMatch": {
      "title": "Invalid New Password",
      "message": "Please enter a new password that does not match your current password."
    },
    "PasswordGenerror": {
      "title": "Your New Password Is Invalid",
      "message": "Please check your new password to make sure that it fits the requirements for passwords."
    }
  },

  "pageContent": {
    "MINCR": {
      "page-header-register": "REGISTER WITH BLUE CROSS"
    },
    "DEFAULT": {
      "page-header-register": "REGISTER WITH HIGHMARK"
    },
    "WY": {
      "page-header-register": "REGISTER WITH BCBSWY"
    },
    "ND": {
      "page-header-register": "REGISTER WITH BCBSND"
    }
  }

}


